<template>
  <form class="form" method="get">

    <div class="fontInvoice">
      <div class="invoiceBlocButton">
        <button @click.prevent="printing()" type="submit" class="appButtonModel2 appPrintButton">Imprimer</button>
        <button @click.prevent="returnTo()" type="submit" class="appButtonModel2 appPrintButton">Retour</button>
      </div>
      <div class="appStatisticsPDFEntete">
        <p>Registre des Dépenses</p>
        <img src="../../assets/Logo1.png" alt="logo de Privilégia Coiffure" class="appLogoPrivilegiaInvoice" />
      </div>
      <div class="appStatisticsPDFEntete2">
        <p>Du</p>
        <p id="datePDFSpending1"></p>
        <p>Au</p>
        <p id="datePDFSpending2"></p>
        <p>Nombre : </p>
        <p id="appNumberSpendings"></p>
      </div>
      <table class="appStatisticsPDFTable">
        <tr>
          <td class="appStatisticsPDF04">Date</td>
          <td class="appStatisticsPDF03">Référence pièce</td>
          <td class="appStatisticsPDF03">Fournisseur</td>
          <td class="appStatisticsPDF01">Nature</td>
          <td class="appStatisticsPDF02">Montant</td>
          <td class="appStatisticsPDF03">Mode de règlement</td>
        </tr>
        <tr :key="index" v-for="(spending, index) in spending">
          <td class="appStatisticsPDF04 appStatisticsPDFItalic">{{ format_date(spending.date) }}</td>
          <td class="appStatisticsPDF03 appStatisticsPDFItalic">{{ spending.reference }}</td>
          <td class="appStatisticsPDF03 appStatisticsPDFItalic">{{ spending.supplier }}</td>
          <td class="appStatisticsPDF01 appStatisticsPDFItalic">{{ spending.category }}</td>
          <td class="appStatisticsPDF02 appStatisticsPDFItalic">{{ (spending.price).toFixed(2) + '€' }}</td>
          <td class="appStatisticsPDF03 appStatisticsPDFItalic">{{ spending.typeofpaiement }}</td>
        </tr>
        <tr>
          <td colspan="4" class="appStatisticsPDF04">Total</td>
          <td colspan="2" class="appStatisticsPDF03" id="totalSpending"></td>
        </tr>
      </table>
    </div>

  </form>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  name: 'appStatisticsPDFSpending',
  data () {
    return {
      spending: ''
    }
  },
  mounted () {
    let date1 = localStorage.getItem('privilegiaPDFdate1')
    let date2 = localStorage.getItem('privilegiaPDFdate2')
    let totalSpending = 0
    document.getElementById('datePDFSpending1').innerText = this.format_date(date1)
    document.getElementById('datePDFSpending2').innerText = this.format_date(date2)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/depenses'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.newResponse = response.data.filter(response => response.category)
        this.newResponse2 = this.newResponse.filter(newResponse => newResponse.date >= date1 && newResponse.date <= date2)
        this.spending = this.newResponse2.sort(function tri (a, b) {
          if (a.date < b.date) { return 1 }
          if (a.date === b.date) { return 0 }
          if (a.date > b.date) { return -1 }
        })
        let myTotalCounter = this.spending.length
        document.getElementById('appNumberSpendings').innerText = myTotalCounter
        for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
          totalSpending = totalSpending + this.spending[myCounter].price
          document.getElementById('totalSpending').innerText = totalSpending.toFixed(2) + '€'
        }
      })
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    printing () {
      print()
    },
    returnTo () {
      localStorage.removeItem('privilegiaPDFdate1')
      localStorage.removeItem('privilegiaPDFdate2')
      this.$router.go(-1)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppStatisticsPDFSpending.vue